import {
	AnwThemeProvider,
	Container,
	Heading,
	Paragraph,
} from '@audio-network/componentlibrary'
import { Button } from '@audio-network/componentlibrary'
import type { GetServerSideProps } from 'next'
import { useEffect, useState } from 'react'
import { StyleSheetManager } from 'styled-components'

import { WorkingArea } from '@/constants/user/userWorkingArea'
import {
	handleCreateCart,
	handleCreateUser,
	handleLogin,
	handleLogout,
} from '@/utils/development/loginUtils'
import { withGlobalTranslations } from '@/utils/i18n/withGlobalTranslations'

import getCurrentSession from '../services/sessionService'
import styles from './login.module.css'

const users = [
	{ email: 'testuser@audionetwork.com', label: 'Ecommerce' },
	{ email: 'testmember@audionetwork.com', label: 'Account Managed' },
	{ email: 'testmember3@audionetwork.com', label: 'Account Managed 2' },
	{
		email: 'testsfx@audionetwork.com',
		label: 'Account Managed with Sound Effects',
	},
	{
		email: 'testlapsedmember@audionetwork.com',
		label: 'Lapsed Account Managed',
	},
	{
		email: 'sitemanageradmin@audionetwork.com',
		label: 'Audio Network Staff User',
	},
	{ email: 'ocollaborator@dispostable.com', label: 'Collaborator Admin' },
	{ email: 'ccollaborator@dispostable.com', label: 'Collaborator User' },
]

export default function LoginPage(): JSX.Element {
	const [loadingUserId, setLoadingUserId] = useState<string | null>(null)
	const [error, setError] = useState<string | null>(null)
	const [loggedInUser, setLoggedInUser] = useState<string | null>(null)

	useEffect(() => {
		getCurrentSession().then((user) => {
			if (user) {
				setLoggedInUser(user.user.email)
			}
		})
	}, [])

	const lowValueWorkingArea = WorkingArea.Games

	return (
		<StyleSheetManager>
			<AnwThemeProvider theme="light">
				<Container maxWidth="medium" className={styles.container}>
					<div className={styles.column}>
						<Heading level={1} size="S">
							Login
						</Heading>
						{users.map((user) => (
							<Button
								key={user.email}
								spinner={loadingUserId === user.email}
								onClick={() =>
									handleLogin(user.email, { setLoadingUserId, setError })
								}
							>
								{user.label}
							</Button>
						))}
					</div>
					<div className={styles.column}>
						<Heading level={2} size="S">
							Actions
						</Heading>
						<Button
							onClick={() => handleCreateUser(setLoadingUserId, setError)}
						>
							High Value Trial User
						</Button>
						<Button
							onClick={() =>
								handleCreateUser(
									setLoadingUserId,
									setError,
									lowValueWorkingArea
								)
							}
						>
							Low Value Non Trial User
						</Button>
						<Button onClick={() => handleCreateCart()}>Give me a cart</Button>
					</div>
				</Container>
				<Container className={styles.actionsContainer}>
					<Button
						variant="secondary"
						onClick={() => handleLogout(setLoggedInUser)}
					>
						Logout
					</Button>
					<Paragraph size="L">
						{loggedInUser ? `Logged in: ${loggedInUser}` : `Not logged in`}
					</Paragraph>
				</Container>
				{error && <Paragraph size="L">{error}</Paragraph>}
			</AnwThemeProvider>
		</StyleSheetManager>
	)
}

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
	return {
		props: {
			...(await withGlobalTranslations(locale)),
		},
	}
}
